<template>
  <section class="challenge">
    <div class="container">
      <a-typography-title :level="1">
        多活部署技术挑战
      </a-typography-title>
      <div class="box_item">
        <div v-for="(item,index) in expand.list"
             class="item" :class="`i_${index+1}`">
          <a-row>
            <a-col :xs="24" :md="4">
              <i />
            </a-col>
            <a-col :xs="24" :md="20">
              <a-typography-title :level="5">
                {{ item.title }}
              </a-typography-title>
              <a-typography-paragraph>
                {{ item.text }}
              </a-typography-paragraph>
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'plan_challenge',
  data(): DataInterface {
    return {
      expand: {
        list: [
          {
            title: '覆盖所有服务，方能真正实现多活',
            text: '企业应用成百上千且不断演进，往往难以精准梳理应用间依赖关系。如果仅针对核心应用实施多活而不覆盖相应应用依赖，多活效果往往不如预期。'
          },
          {
            title: '需要覆盖所有技术栈，技术难度大',
            text: '为确保业务稳定运行，所有中间件都需要支持双活，除主流技术外，自研组件以及后续要迭代的新技术，都需要做多机房数据同步，技术难度较高。'
          },
          {
            title: '应用配套系统需要高度自动化',
            text: '多活业务的配套服务和流程，如发布、测试、监控、降级系统，都需要进行相应多活改造。为降低配套系统的运维工作量，系统高度自动化成为必需。'
          }
        ]
      }
    };
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/planActive/';

.challenge {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background: @color_7;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

.box_item {
  position: relative;
  max-width: 1000px;
  margin: @margin auto 0;
  
  .item {
    @wh: 80px;
    position: relative;
    padding: 20px;
    margin: 20px 0 0;
    background: @color_white;
    border: 2px solid @color_14;
    border-radius: 8px;
    
    .loop(@i) when (@i<=3) {
      &.i_@{i} {
        i {
          background-position: -@wh*(-1+@i) 0;
        }
      }
      .loop(@i+1);
    }
    .loop(1);
    
    &:first-child {
      margin: 0;
    }
    
    i {
      display: block;
      width: @wh;
      height: @wh;
      margin: 0 auto;
      .bg('@{image}challenge_icon.png', @wh*3, @wh);
    }
    
    h5.ant-typography {
      margin: 0;
      .font(left, @text_big, @color_12, @text_big, true);
    }
    
    div.ant-typography {
      margin: 10px 0 0;
      .font(left, @text+@line, @color_13, @text);
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .challenge {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  .box_item {
    margin: @margin_mo 0 0;
    
    .item {
      h5.ant-typography {
        margin: @margin_mo auto 0;
        .font(center, @text_big_mo, @color_12, @text_big_mo, true);
      }
      
      div.ant-typography {
        .font(left, @text_mo+@line_mo, @color_13, @text_mo);
      }
    }
  }
}
</style>